/* eslint-disable no-param-reassign */
import {
  createReducer,
  createSelector,
  createAsyncThunk,
} from '@reduxjs/toolkit'
import { redFunnelAPI } from '../api/api'
import { selectUser, logout } from './authentication'

const initialState = {
  loading: false,
  vehicles: null,
  error: null,
}

export const fetchUserVehicles = createAsyncThunk(
  'userVehicles/fetch',
  (args, thunkAPI) => {
    const user = selectUser(thunkAPI?.getState())
    return redFunnelAPI.getUserVehicles(user?.customerNumber)
  },
)

export const updateUserVehicles = createAsyncThunk(
  'userVehicles/update',
  (args, thunkAPI) => {
    const user = selectUser(thunkAPI?.getState())
    return redFunnelAPI.updateUserVehicle({
      customerNumber: user?.customerNumber,
      vehicles: args,
    })
  },
)

export const userVehiclesReducer = createReducer(initialState, builder => {
  builder.addCase(fetchUserVehicles.pending, state => {
    state.loading = true
  })
  builder.addCase(fetchUserVehicles.rejected, (state, action) => {
    state.loading = false
    state.error = action.error?.message
  })
  builder.addCase(fetchUserVehicles.fulfilled, (state, action) => {
    state.loading = false
    state.error = null
    state.vehicles = action.payload
  })
  builder.addCase(updateUserVehicles.pending, state => {
    state.loading = true
  })
  builder.addCase(updateUserVehicles.rejected, state => {
    state.loading = false
  })
  builder.addCase(updateUserVehicles.fulfilled, (state, action) => {
    state.loading = false
    state.vehicles = action.payload
  })
  builder.addCase(logout.fulfilled, state => {
    state.vehicles = null
  })
})

export const selectUserVehicleState = state => state?.userVehicles

export const selectUserVehicles = createSelector(
  selectUserVehicleState,
  state => {
    return state?.vehicles || []
  },
)
